import './App.css'
import { Role } from '@common/enums/request.enums'
import PageContainer from '@components/layout/PageContainer'
import Forbidden from '@components/pages/Forbidden'
import NotFound from '@components/pages/NotFound'
import Unauthorized from '@components/pages/Unauthorized'
import { Route as RoutePath } from '@config/routes/routes.enums'
import React from 'react'
import {
	Navigate,
	Route,
	Routes
} from 'react-router-dom'
import Analytics from './modules/analytics/Analytics'
import Login from './modules/auth/Login'
import ProtectedRoute from './modules/auth/ProtectedRoute'
import TraineesManagement from './modules/dashboard/TraineesManagement'
import Trainee from './modules/trainee/Trainee'

/**
 * App
 * @constructor
 */
const App = () => {
	return (
		<div className="App">
			<Routes>
				{/* Authentication */}
				<Route path={RoutePath.LOGIN} element={<Login />} />

				{/* Modules */}
				<Route element={<PageContainer />}>
					{/* Trainees */}
					<Route element={<ProtectedRoute roles={[Role.ADMIN, Role.USER]} />}>
						<Route path={RoutePath.TRAINEES}>
							<Route path=":id" element={<Trainee />} />
							<Route index element={<TraineesManagement />} />
						</Route>
					</Route>

					{/* Analytics */}
					<Route element={<ProtectedRoute roles={[Role.ADMIN]} />}>
						<Route path={RoutePath.ANALYTICS} element={<Analytics />} />
					</Route>

					{/* Default */}
					<Route index element={<Navigate to={RoutePath.TRAINEES} replace />} />
				</Route>

				{/* Error pages */}
				<Route path={RoutePath.UNAUTHORIZED} element={<Unauthorized />} />
				<Route path={RoutePath.FORBIDDEN} element={<Forbidden />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</div>
	)
}

export default App
